import { render } from "./DashboardComponent.vue?vue&type=template&id=5392d9a4&scoped=true"
import script from "./DashboardComponent.vue?vue&type=script&lang=js"
export * from "./DashboardComponent.vue?vue&type=script&lang=js"

import "./DashboardComponent.vue?vue&type=style&index=0&id=5392d9a4&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-5392d9a4"

export default script